import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, addDoc, doc, deleteDoc } from 'firebase/firestore';
import {projectAuth, projectFirestore, projectStorage} from '../firebase/config';
import {onAuthStateChanged} from "firebase/auth";
import { ref, getStorage, uploadBytes, getDownloadURL } from 'firebase/storage';
import Resizer from 'react-image-file-resizer';

const Gallery = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const imagesCollection = collection(projectFirestore, 'images');
                const snapshot = await getDocs(imagesCollection);
                const images = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setData(images);
            } catch (err) {
                setError(err.message);
                console.error("Error fetching data:", err);
            }
        };

        fetchData();

        const unsubscribe = onAuthStateChanged(projectAuth, (user) => {
            if (user) {
                setUser(user);
            } else {
                setUser(null);
            }
        });

        return () => unsubscribe();
    }, []);

    const fileUpload = async (e) => {
        e.preventDefault();

        if (!file) {
            setError("Maximální velikost souboru je 2 MB. Soubor zmenši a načti stránku znovu.");
            return;
        }

        const storage = getStorage();

        // Upload original image
        const originalRef = ref(storage, `images/original/${file.name}`);
        const thumbnailRef = ref(storage, `images/thumbnail/${file.name}`);

        try {
            // Upload the original file
            await uploadBytes(originalRef, file);
            const originalUrl = await getDownloadURL(originalRef);

            // Resize and upload the thumbnail
            Resizer.imageFileResizer(
                file,
                300, // Thumbnail width
                300, // Thumbnail height
                "JPEG",
                100,
                0,
                async (thumbnail) => {
                    await uploadBytes(thumbnailRef, thumbnail);
                    const thumbnailUrl = await getDownloadURL(thumbnailRef);

                    // Save both URLs to Firestore
                    const docRef = await addDoc(collection(projectFirestore, 'images'), {
                        originalUrl: originalUrl,
                        thumbnailUrl: thumbnailUrl,
                        timestamp: new Date(),
                    });

                    const newImage = {
                        id: docRef.id,
                        originalUrl: originalUrl,
                        thumbnailUrl: thumbnailUrl,
                        timestamp: new Date(),
                    };

                    setData(prevData => [...prevData, newImage]);
                },
                "blob"
            );

        } catch (err) {
            console.error("File upload error:", err);
            setError("Upload failed, please try again.");
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        const maxSize = 2 * 1024 * 1024; // 2 MB
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

        if (selectedFile) {
            if (!allowedTypes.includes(selectedFile.type)) {
                setError("Povoleny jsou pouze soubory typu JPG, JPEG a PNG. Načti stránku znovu a nahraj jiný soubor.");
                setFile(null);
                return;
            }

            if (selectedFile.size > maxSize) {
                setError("Maximální velikost souboru je 2 MB. Soubor zmenši a načti stránku znovu.");
                setFile(null);
            } else {
                setError(null); // Clear any previous error
                setFile(selectedFile);
            }
        }
    };

    const fileDelete = async (id) => {
        try {
            const docRef = doc(projectFirestore, 'images', id);
            await deleteDoc(docRef);

            setData(prevData => prevData.filter(image => image.id !== id));

        } catch (err) {
            setError(err.message);
        }
    }

    if (error) {
        return <div className="container"><div className="alert alert-danger mt-2">{error}</div></div>;
    }

    return (
        <div className="container">
            <div className="p-4 border mb-5">
                {user && (
                    <form onSubmit={fileUpload}>
                        <div className="alert alert-info mt-2">Maximální velikost souboru je 2 MB</div>
                        <div className="col-6">
                            <div className="input-group">
                                <input
                                    className="form-control"
                                    onChange={handleFileChange}
                                    type="file"
                                    name="fileUpload"
                                />
                                <button type="submit" className="btn btn-outline-secondary">Nahrát</button>
                            </div>
                        </div>
                        {error && <div className="alert alert-danger mt-2">{error}</div>}
                    </form>
                    )}
            </div>

            {data.length > 0 ? (

                <div className="p-4 border">
                    <div className="row justify-content-start gallery">
                        {data
                            .sort((a, b) => b.timestamp - a.timestamp)
                            .map(image => (
                                <div className="img-item col-3" key={image.id}>
                                    <div className="img-inner">
                                        <a href={image.originalUrl}>
                                            <img className={user && ("img-thumbnail")} src={image.thumbnailUrl} style={{ width: '100%' }} />
                                        </a>
                                    {user && (
                                        <div onClick={() => fileDelete(image.id)} className="btn btn-danger remove"
                                             aria-label="Close">
                                        </div>
                                    )}
                                </div>
                            </div>
                            ))}
                    </div>
                </div>
            ) : (
                <p>No images found.</p>
            )}

        </div>
    );
};

export default Gallery;
